/**
 * @file
 * Trigger for see more button.
 */

((Drupal, once) => {
  /**
   * Trigger for using more button on person teaser.
   */
  Drupal.behaviors.seeMoreButtonTrigger = {
    attach: function attach(context) {
      // Event see more toggle.
      once("seeMoreButton", ".person-wrapper .see-more", context).forEach(
        (seeMore) => {
          seeMore.addEventListener("click", (event) => {
            event.target.parentNode
              .querySelectorAll(".person-body")
              .forEach((content) => {
                content.classList.toggle("d-none");
              });
            event.target.querySelectorAll("span").forEach((span) => {
              span.classList.toggle("d-none");
            });
          });
        }
      );
    },
  };
})(Drupal, once);
